// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2QgeT","topBottomGutter":"Layout_topBottomGutter__2J45M"};